import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Select } from 'formlabs-web-components/Form';

import './SortControl.module.css';

const SortControl = ({ productCount, setOrder, order }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('default');

  const handleChange = event => {
    setOrder(event.target.value);
    setValue(event.target.value);
  };

  return (
    <label styleName="sort">
      <span>{t('Sort {{count}} items by', { count: productCount })}: </span>
      <div styleName="sort-sizing">
        <Select value={order ? order : value} onChange={handleChange}>
          <option value="default">{t('Popularity')}</option>
          <option value="alpha">{t('Alphabetical')}</option>
          <option value="date">{t('Release Date')}</option>
          <option value="priceDesc">{t('Price: High to Low')}</option>
          <option value="priceAsc">{t('Price: Low to High')}</option>
        </Select>
      </div>
    </label>
  );
};

export default SortControl;
